import axios from "axios";
import { getStoredEmail } from "./accountsApi";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
const API = `${BACKEND_URL}/api/clients`;

function authHeaders() {
  const email = getStoredEmail();
  return email ? { "X-Account-Email": email } : {};
}

export async function listarClientes({ archivados = false } = {}) {
  const { data } = await axios.get(API, {
    headers: authHeaders(),
    params: archivados ? { archivados: 1 } : {},
  });
  return Array.isArray(data) ? data : [];
}

export async function obtenerCliente(id) {
  const { data } = await axios.get(`${API}/${encodeURIComponent(id)}`, {
    headers: authHeaders(),
  });
  return data;
}

export async function crearCliente(payload) {
  const { data } = await axios.post(API, payload, { headers: authHeaders() });
  return data;
}

export async function actualizarCliente(id, payload) {
  const { data } = await axios.put(`${API}/${encodeURIComponent(id)}`, payload, {
    headers: authHeaders(),
  });
  return data;
}

export async function eliminarCliente(id) {
  await axios.delete(`${API}/${encodeURIComponent(id)}`, {
    headers: authHeaders(),
  });
}

export async function listarDefinicionesCampos() {
  const { data } = await axios.get(`${API}/fields`, { headers: authHeaders() });
  return Array.isArray(data) ? data : [];
}

export async function crearDefinicionCampo(payload) {
  const { data } = await axios.post(`${API}/fields`, payload, {
    headers: authHeaders(),
  });
  return data;
}

export async function actualizarDefinicionCampo(key, payload) {
  const { data } = await axios.put(
    `${API}/fields/${encodeURIComponent(key)}`,
    payload,
    { headers: authHeaders() },
  );
  return data;
}

export async function eliminarDefinicionCampo(key) {
  await axios.delete(`${API}/fields/${encodeURIComponent(key)}`, {
    headers: authHeaders(),
  });
}
